import src from "IMAGE";
export default { src, width: 2000, height: 200, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAH0lEQVR42mNgElTUYRdW1GXil1Vn5JVUYmDj5mdAAgAjzgGHM4cF5AAAAABJRU5ErkJggg=="};
